import { Resource } from 'constants/resources';

import { useState } from 'react';

import { RaRecord, useGetOne, useNotify } from 'react-admin';

type Props = {
  resource: Resource;
  onError?: (error: Error) => void;
};

export function useRecordModalById<T extends RaRecord>({ resource, onError }: Props) {
  const [openRecordModal, setOpenRecordModal] = useState(false);
  const [record, setRecord] = useState<T>();
  const [recordId, setRecordId] = useState<string>();
  const notify = useNotify();

  const { isFetching, error } = useGetOne<T>(
    resource,
    { id: recordId },
    {
      enabled: !!recordId,
      onSuccess: (data) => {
        setRecord(data);
      },
      onError: (error: Error) => {
        onError ? onError(error) : notify(error?.message, { type: 'error' });
        setRecordId(undefined);
        setOpenRecordModal(false);
      },
    },
  );

  const handleOpenRecordModal = (id?: string) => {
    setRecordId(id);
    setOpenRecordModal(true);
  };

  const handleCloseRecordModal = () => {
    setOpenRecordModal(false);
  };

  return {
    record,
    handleOpenRecordModal,
    handleCloseRecordModal,
    openRecordModal,
    isFetching,
    error,
  };
}
